export const Frequency = {
  Daily: 'Daily',
  Cycle: 'Cycle',
  Year: 'Year',
} as const;
export type Frequency = (typeof Frequency)[keyof typeof Frequency];
